// extracted by mini-css-extract-plugin
module.exports = {"effectsGrayscale":"NQXjo","effectsGrayscale30":"_1smRZ","resetList":"_3Klos","wrapper":"_2NVX6","corner":"_2Qg-E"};